module.exports = "pegasus/assets/blocks/social-2-theme6.png";